var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8058 13.4245C25.2513 13.6699 24.6632 13.8311 24.0611 13.9028C24.6953 13.5235 25.1699 12.9266 25.3966 12.2233C24.8002 12.5771 24.1476 12.826 23.4671 12.9594C23.0503 12.5152 22.5096 12.2066 21.9151 12.0734C21.3207 11.9403 20.7 11.9889 20.1336 12.2129C19.5671 12.4369 19.081 12.8259 18.7384 13.3295C18.3957 13.8331 18.2123 14.4281 18.2119 15.0372C18.2114 15.2703 18.2375 15.5027 18.2896 15.7298C17.0822 15.6691 15.9011 15.3552 14.823 14.8085C13.7448 14.2618 12.7936 13.4945 12.0312 12.5564C11.6427 13.225 11.5236 14.0165 11.6982 14.7698C11.8727 15.5231 12.3278 16.1815 12.9707 16.6111C12.4885 16.5963 12.0169 16.4658 11.5956 16.2307V16.271C11.5958 16.9715 11.8381 17.6504 12.2814 18.1928C12.7247 18.7351 13.3418 19.1077 14.0283 19.2473C13.7673 19.3183 13.4981 19.354 13.2277 19.3537C13.0372 19.3537 12.8471 19.3355 12.6601 19.2993C12.8543 19.9028 13.2323 20.4306 13.7411 20.8089C14.2499 21.1871 14.8642 21.3969 15.4981 21.409C14.4214 22.2527 13.0924 22.7102 11.7245 22.708C11.4824 22.7084 11.2404 22.6944 11 22.6661C12.3896 23.559 14.0071 24.0327 15.6589 24.0304C16.7957 24.038 17.9227 23.8197 18.9745 23.3882C20.0263 22.9567 20.9818 22.3205 21.7857 21.5166C22.5896 20.7127 23.2258 19.7572 23.6573 18.7054C24.0888 17.6536 24.3071 16.5266 24.2995 15.3897C24.2995 15.2577 24.2995 15.1273 24.2909 14.9969C24.8855 14.5672 25.3988 14.035 25.8066 13.4253L25.8058 13.4245Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.25,
    stroke: "#5E5E5E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.be8fe4e6e28a4ea20ff80cd74c1b7e2a.svg";
export { ForwardRef as ReactComponent };